import React from "react";
import { Instant } from "@js-joda/core";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { checkIfDataInCurrentMonthExists, getMonthValuesForYears } from "utils/time-utils";
import { useCompanyTimezone } from "hooks/useTimezone";
import DiffValueDisplayer from "./DiffValueDisplayer";
import { formatDiff, getMonthYearComparison } from "./ValueChangeIndicatorUtils";
import { DataDisplayType, DiffValueOptions, ValueChangeIndicatorProps } from "./ValueChangeIndicatorTypes";
import NoDataInCurrentMonth from "./NoDataInCurrentMonth";

const DiffValueForMonthYearComparison = (
  props: ValueChangeIndicatorProps & {
    dataRange?: DatasetDataInfoResponse[];
    refTime: Instant;
    currentDiffValueOptions: DiffValueOptions;
    currentDataset?: DatasetDataInfoResponse;
    diffDecimalPlaces?: number;
  }
) => {
  const companyTz = useCompanyTimezone();
  if (props.dataDisplayType === DataDisplayType.MONTH_YEAR_COMPARISON && props.dataRange) {
    const dataset = props.dataRange[0]?.data ?? [];
    const dataToUse = getMonthValuesForYears(dataset, companyTz, props.refTime);
    const currentEntry = dataToUse?.[1];

    if (!currentEntry?.key || !checkIfDataInCurrentMonthExists(currentEntry.key, companyTz, props.refTime)) {
      return <NoDataInCurrentMonth tz={companyTz} refTime={props.refTime} theme={props.theme} />;
    }

    const { prev } = getMonthYearComparison(dataset, companyTz, props.refTime);
    const { curr } = getMonthYearComparison(dataset, companyTz, props.refTime);

    if (curr == null || prev == null) return null;
    const diffValue = props.currentDiffValueOptions.value || (curr ?? 0) - (prev ?? 0);

    return (
      <DiffValueDisplayer
        dataDisplayType={props.dataDisplayType}
        useDiffIndicatorColors={props.useDiffIndicatorColors}
        diffValue={diffValue}
        diffValueDecimalPlaces={props.diffValueDecimalPlaces}
        formattedValue={formatDiff(
          prev,
          curr,
          props.currentDataset?.unit,
          diffValue,
          false,
          props.diffType,
          props.diffDecimalPlaces,
          props.dataDisplayType
        )}
      />
    );
  }
  return null;
};

export default DiffValueForMonthYearComparison;
